import { Button } from '@/components/ui/button';
import { reloadApp } from '@/lib/appRecovery';
import { RefreshCw } from 'lucide-react';

export default function AppRecoveryScreen() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center text-foreground" role="alert">
      <h1 className="text-2xl font-heading">Masira couldn’t load</h1>
      <p className="text-muted-foreground">Please try again. Your saved learning is safe.</p>
      <Button variant="outline" onClick={reloadApp}><RefreshCw aria-hidden="true" />Try again</Button>
    </main>
  );
}